export default "__VITE_ASSET__DIZArcly__";